import { AlertCircle, CheckCircle2, LoaderCircle } from 'lucide-react'

type FormStatusProps = {
  status: 'idle' | 'submitting' | 'success' | 'error'
  message?: string
}

export function FormStatus({ status, message }: FormStatusProps) {
  if (status === 'idle') return null
  return (
    <div className={`form-status is-${status}`} role="status" aria-live="polite">
      {status === 'submitting' && <LoaderCircle className="spin" size={20} />}
      {status === 'success' && <CheckCircle2 size={20} />}
      {status === 'error' && <AlertCircle size={20} />}
      <span>{message}</span>
    </div>
  )
}
